import { createSelector } from "reselect";

export const selectIsLoadingBroadcasts = (state) =>
  state.arrivideo?.loadingBroadcasts;
export const selectIsLoadingContentItems = (state) =>
  state.arrivideo?.loadingContentItems;
export const selectIsLoadingFolders = (state) =>
  state.arrivideo?.loadingFolders;

export const selectBroadcasts = (state) => state.arrivideo?.broadcasts || [];
export const selectContentItems = (state) =>
  state.arrivideo?.contentItems || [];
export const selectFolders = (state) => state.arrivideo?.folders || [];

export const selectBroadcastById = createSelector(
  [(state, props) => props.identifier, selectBroadcasts],
  (broadcastId, broadcasts) => {
    if (!broadcasts || broadcasts.length === 0) return false;
    if (!broadcastId) return undefined;
    return broadcasts.find((entry) => entry.id === broadcastId);
  },
);

export const selectContentItemById = createSelector(
  [(state, props) => props.identifier, selectContentItems],
  (contentItemId, contentItems) => {
    if (!contentItems || contentItems.length === 0) return false;
    if (!contentItemId) return undefined;
    return contentItems.find((entry) => entry.id === contentItemId);
  },
);

const selectPropAsValue = (_, props) => props.value;

export const selectContentsByBroadcastId = createSelector(
  [selectContentItems, selectBroadcasts, selectPropAsValue],
  (contentItems, broadcasts, broadcastId) => {
    if (!contentItems || !broadcasts || !broadcastId) return undefined;
    const broadcast = broadcasts.find((entry) => entry.id === broadcastId);

    if (!broadcast) return undefined;
    return broadcast.content
      .map((contentItem) =>
        contentItems.find((item) => item.id === contentItem.id),
      )
      .filter(Boolean);
  },
);

export const selectBroadcastsSortedByUpdatedAt = createSelector(
  [selectBroadcasts],
  (broadcasts) => {
    if (!broadcasts) return [];
    return [...broadcasts].sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
    );
  },
);

export const selectContentItemsSortedByUpdatedAt = createSelector(
  [selectContentItems],
  (contentItems) => {
    if (!contentItems) return [];
    return [...contentItems].sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
    );
  },
);

export const selectFolderById = createSelector(
  [(state, props) => props.identifier, selectFolders],
  (folderId, folders) => {
    if (!folderId || !folders || folders.length === 0) return false;
    return folders.find((folder) => folder.id === folderId);
  },
);
